import { MarkupType } from "application-types";
import { isNumberTwoDecimalPlaces } from "./isNumberTwoDecimalPlaces";

export function isMarkupValueValid(markup: MarkupType | undefined): boolean {
  if (!markup) {
    return true;
  }

  if (markup.value === '' || markup.value === undefined) {
    return false;
  }

  const numValue = Number(markup.value);

  if (numValue < 0) {
    return false;
  }

  return isNumberTwoDecimalPlaces(parseFloat(markup.value));
}
